var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.values),function(value){return _c('li',{key:value},[_vm._v(_vm._s(_vm.computeForValue(value)))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }